import api from "../../../../../api";

export const requestStoreData = async (selectedMake) => {
  const modelResponse = await api.get(`/makemodels/${selectedMake.id_car_make}`);
  const fetchedModels = modelResponse.data;

  const allGenerations = [];
  const enginesMap = {};
  const generationToModelMap = {};

  for (const model of fetchedModels) {
    const genResponse = await api.get(`/modelgenerations/${model.id_car_model}`);
    const gens = genResponse.data;

    for (const gen of gens) {
      generationToModelMap[gen.id_car_generation] = model;
      allGenerations.push(gen);

      const enginesResponse = await api.get(`/generationmotor/${gen.id_car_generation}`);
      enginesMap[gen.id_car_generation] = enginesResponse.data;
    }
  }

  return {
    generations: allGenerations,
    enginesByGeneration: enginesMap,
    generationToModel: generationToModelMap
  };
};
